<label class="custom-search-input">
  <i class="lvi-thel-loupe"></i>
  <app-custom-input [val]="val" (valChange)="onSearchClick($event)" i18n-placeholder="@@Rechercher" placeholder='Rechercher...' ></app-custom-input>
  <i class="lvi-icon-cross" tooltip [tooltipPosition]="'bottom'" i18n-tooltipContent="@@EffacerLaRecherche" tooltipContent="Effacer la recherche" *ngIf="val" (click)="onRemoveClick()"></i>
</label>
